import { connect } from 'react-redux';
import { blotterPanelItemDetailsDismissAlert } from 'state/blotters/blotterPanel/blotterPanel.action';
import {
  getBlotterPanelItem,
  getBlotterPanelItemFetchErrorDetails,
  isBlotterPanelItemFetchingFailed,
  isBlotterPanelItemFetchingFailedShowAlert,
  isFetchingBlotterPanelItemDetails,
} from 'state/blotters/blotterPanel/blotterPanel.selector';
import { getBlotterType } from 'state/selectors/common/misc';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

import type { BlotterPanelDispatchProps, BlotterPanelStateProps } from './BlotterPanel';
import { BlotterPanelComponent } from './BlotterPanel';

export const mapStateToProps = (state: AppState): BlotterPanelStateProps => {
  const blotterItem = getBlotterPanelItem(state);
  return {
    blotterItem,
    blotterType: getBlotterType(state, blotterItem),
    isFetching: isFetchingBlotterPanelItemDetails(state),
    isFetchingFailed: isBlotterPanelItemFetchingFailed(state),
    isShowFailedAlert: isBlotterPanelItemFetchingFailedShowAlert(state),
    fetchErrorDetails: getBlotterPanelItemFetchErrorDetails(state),
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): BlotterPanelDispatchProps => {
  return {
    onDismissAlertClicked() {
      dispatch(blotterPanelItemDetailsDismissAlert());
    },
  };
};

export const BlotterPanel = connect(mapStateToProps, mapDispatchToProps)(BlotterPanelComponent);
